module.exports = __webpack_public_path__ + "img/svg/multiplayer-competition-card.5c3f5caddc3b33ca6b9449fd1d0e0a40.svg";